<template>
  <div class="Heshid">
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>
    <v-dialog v-model="modalpilihhid" persistent width="500">
      <v-card>
        <v-form ref="formpilihhid">
          <v-card-title class="text-h5 grey lighten-2">
            {{ $t("masukhid") }}
          </v-card-title>
          <v-container>
            <v-text-field
              outlined
              dense
              rounded
              v-model="pilihhid"
              :rules="[required('HID')]"
              label="HID"
            ></v-text-field>
            <!-- <ul>
                <li v-for="item in test" :key="item.message">
                  {{ item.message }}
                </li>
              </ul> -->
          </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red accent-4 white--text"
              @click="tutupmodalpilihhid">
              {{ $t("tutup") }}
            <v-icon dark right> mdi-close-circle</v-icon></v-btn>
            <v-btn color="light-blue white--text" @click="paparpilihhid">
              {{$t("hantar")}} 
             <v-icon dark right> mdi-arrow-right-bold-circle-outline</v-icon></v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import i18n from "@/i18n";
export default {
  Name: "Heshid",
  setup() {},
  data: () => ({
    snackbar:"",
    modalpilihhid: true,
    pilihhid: "",
    required(text){
        return (v) => 
        (v && v.length > 0) || `${i18n.t(text)} ${i18n.t('adalah diperlukan')}`
    }
  }),

  methods: {
    async tutupmodalpilihhid() {
      this.$router.push(`/${i18n.locale}/paparanutama`);
    },
    async paparpilihhid() {
      try {
        if (this.$refs.formpilihhid.validate()){
          if (this.pilihhid.length >= 26) {
            await axios
              .post(`${process.env.VUE_APP_API_URL}/JR/semakheshis`, {
                semakhidjr2: this.pilihhid,
              })
              .then((result) => {
                console.log(result.data.data);
                if (typeof result.data.data !== "undefined" ) {
                  //console.log(result.data.data.HID);
                  axios
                    .get(
                      `${process.env.VUE_APP_API_URL}/auth/encode?en=${result.data.data.HID}`
                    )
                    .then((result) => {
                      this.$router.push(
                        `/${i18n.locale}/BLK3PreCode/${result.data.encode}`,
                        () => {}
                      );
                      // this.$router.go();
                    });
                } else {
                  this.snackbar = {
                    message: i18n.t("tiadahiddijumpai"),
                    timeout: 2000,
                    color: "red darken-4",
                    show: true,
                  };
                }
              });
          } else {
            console.log('sss')
            this.snackbar = {
              message: i18n.t("cubalagi"),
              timeout: 2000,
              color: "red darken-4",
              show: true,
            };
          }
        }
      } catch (err) {
        alert(err);
      }
    },
  },
};
</script>

